import React from "react";
import styled from "styled-components";
import Header from "./Header";

const HomePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 12rem;
  @media (max-width: 768px) {
    padding-top: 4rem;
  }
`;

function HomePage() {
  return (
    <HomePageContainer>
      <Header />
    </HomePageContainer>
  );
}

export default HomePage;
